import './index.css';
import { useEffect, useState } from 'react';
import Loader from '../../../components/Loader';
import { useNavigate, useParams } from 'react-router-dom';
import Hero from '../../../components/Hero';
import LinkBack from '../../../components/LinkBack';
import ButtonShareWsp from '../../../components/ButtonShareWsp';
import Button from '../../../components/Button';
import Footer from '../../../components/Footer';

export default function UuidChuch() {
    const { uuid_church } = useParams();
    const navigate = useNavigate();

    const [church, setChurch] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (uuid_church) {
            const apiUrl = `/api/churches/?uuid_church=${uuid_church}`;
            const fetchData = async () => {
                try {
                    const response = await fetch(apiUrl);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const jsonData = await response.json();
                    setChurch(jsonData);
                    setLoading(false);
                } catch (e) {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [uuid_church]);

    if (loading || church === null) {
        return <Loader topAvance={150} />;
    }
    const handleBackNavigate = () => {
        navigate(-1)
    }

    const addressMaps = `${church.address_gmaps}, ciudad ${church.city}, región ${church.region}`;
    const addressLocationMaps = `https://maps.google.com/maps?q=${encodeURIComponent(addressMaps)}&output=embed`;
    const addressLocationMapsShare = `https://maps.google.com/maps?q=${encodeURIComponent(addressMaps)}`;

    return (
        <main className="g-main uuid_church">
            <Hero title={church.name} description={`Encargado ${church.manager || 'no informado'}`} size="s" />
            <section className="content-main">
                <LinkBack to="/iglesias/" text="Volver a Iglesias" />
                <div className="g-share-wsp">
                    <ButtonShareWsp
                        url={window.location.href}
                        text={`Quiero compartir la siguiente información: ${church.name} ubicada en ${church.address} ${church.city}, región ${church.region}\n\n`}
                    >
                        <Button label="Compartir" />
                    </ButtonShareWsp>
                </div>
                <div className="content-data-church">
                    <p>Dirección: {church.address}, {church.city}, región {church.region}</p>
                    <p>Encargado: {church.manager || 'No informado'}</p>
                    <p>Email: {church.email || 'No informado'}</p>
                    <p>Teléfono: {church.phone || 'No informado'}</p>
                    <p>Sitio web: {church.website || 'No informado'}</p>
                    <div className="g-share-wsp">
                        <ButtonShareWsp
                            url={addressLocationMapsShare}
                            text={`Quiero compartir contigo la ubicación de: ${church.name} ubicada en ${church.address} ${church.city}, región ${church.region}\n\n
                            `}
                        >
                            <Button label="Compartir ubicación" />
                        </ButtonShareWsp>
                    </div>
                    <iframe
                        className="iframe-googlemaps-embed"
                        src={addressLocationMaps}
                        allowFullScreen=""
                        loading="lazy"
                        title={`Ubicación de ${church.name}, ${church.city}`}
                        referrerpolicy="no-referrer-when-downgrade"
                    />
                </div>
            </section>
            <Footer />
        </main>
    );
}